import { useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import Overlay from 'lib/Overlay';
import { thoughtspot } from 'config';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import { labsReportVisibleActions, filterByAssetOwner, hiddenAssetOwnerThoughtspotLiveboardStyles } from '../utils';
import { getUpdateParametersForTimeRange, getUpdateParametersForTimezone } from '../../utils';
import { LabsLiveboardProps } from '../LabsLiveboard.types';

export const DealHealthUSLiveboard: React.FC<LabsLiveboardProps> = ({ showLiveboard, onHideLiveboard }) => {
  const { marketId, timezone, timezoneOverride } = useSelector((state: Store) => state.publisher.configuration);

  const today = new Date();
  const liveboardUpdateParameters = [
    ...getUpdateParametersForTimezone(timezoneOverride ?? timezone),
    ...getUpdateParametersForTimeRange({ startDate: today, endDate: today }),
  ];

  if (!showLiveboard) return null;
  return (
    <Overlay
      onClose={onHideLiveboard}
      isOpen={showLiveboard}
      childrenExtraStyles="flex"
      header={
        <header>
          <h3 className="sub-header-lg text-neutral-900">Deal Health 2.0</h3>
        </header>
      }
    >
      <LiveboardVisuals
        liveboardId={thoughtspot.dealHealthUSDashboardId}
        customizations={hiddenAssetOwnerThoughtspotLiveboardStyles}
        visibleActions={labsReportVisibleActions}
        filterByOptions={[filterByAssetOwner(marketId)]}
        updateLiveboardParameters={liveboardUpdateParameters}
      />
    </Overlay>
  );
};
